/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_ToolsInputs */



/**
* | output |
* | --- |
* | "QuickTools" |
*
* @param {Quick_ToolsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quick_tools = /** @type {((inputs?: Quick_ToolsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_ToolsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Outils rapides")
	if (locale === "de") return /** @type {LocalizedString} */ ("QuickTools")
	if (locale === "it") return /** @type {LocalizedString} */ ("Strumenti rapidi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Быстрые инструменты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Herramientas rápidas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快速工具")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クイックツール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्विकटूल्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ferramentas Rápidas")
	return /** @type {LocalizedString} */ ("QuickTools")
});